// extracted by mini-css-extract-plugin
export default {"filters":"FiltersBlock_filters__G1YXf","filters_close":"FiltersBlock_filters_close__mQj1i"};